import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { User, Register, Login, Office, Search } from './user.model';

@Injectable()
export class UserService {
  
 //readonly rootUrl = 'http://localhost:14050';
readonly rootUrl = 'http://ticketapi.vikasglobal.net';
//readonly rootUrl = 'http://ticketstagingapi.vikasglobal.net';
  httpOptions: any;

  constructor(private http: HttpClient) {
    let accesstoken = localStorage.getItem('accessToken');
    if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + accesstoken,
          'No-Auth': 'True'
        })
      };
    }
  }

  getAllowedPages() {
    let accesstoken = localStorage.getItem('accessToken'); 
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accesstoken
      })
    };
    return this.http.get(this.rootUrl + '/api/AllowedPages', this.httpOptions);
  }

  getAllRoles(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }

  getAllUsers(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  getAllTickets() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetAll', this.httpOptions);
  }
  getAllProspects() {
    return this.http.get(this.rootUrl + '/api/Marketing/GetAll', this.httpOptions);
  }
  GetAllTelecallerAlert() {
    return this.http.get(this.rootUrl + '/api/Marketing/GetAllTelecallerAlert', this.httpOptions);
  }

  GetNotificationPopup() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetNotificationPopup', this.httpOptions);
  }
  GetProjNotification() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetProjNotification', this.httpOptions);
  }

  GetAllProspectsforMarketing() {
    return this.http.get(this.rootUrl + '/api/Marketing/GetAllProspectsforMarketing', this.httpOptions);
  }
  GetAllProspectAlert() {
    return this.http.get(this.rootUrl + '/api/Marketing/GetAllPropectsAlert', this.httpOptions);
  }
  getAllInternalTickets() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetAllInternalTickets', this.httpOptions);
  }
  getIssueAlert() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueAlert', this.httpOptions);
  }

  getIssueAlertClosed() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueAlertClosed', this.httpOptions);
  }

  getIssueAlertNew() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueAlertNew', this.httpOptions);
  }

  getUsers() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetUsers', this.httpOptions);
  }
  GetTicketCount() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetTicketCount', this.httpOptions);
  }
  getAllClaimsForTheRole(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Claims/GetClaims/' + roleId, this.httpOptions);
  }
  getRoleForTheId(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Roles/' + roleId, this.httpOptions);
  }

  getUserForTheId(Id: string) {
    return this.http.get(this.rootUrl + '/api/Users/' + Id, this.httpOptions);
  }

  GetIssueForTheId(IS_Id: any) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/' + IS_Id, this.httpOptions);
  }
  GetProspectForTheId(Pros_Id: any) {
    return this.http.get(this.rootUrl + '/api/Marketing/' + Pros_Id, this.httpOptions);
  }

  GetProspectDetailForTheId(Pros_Id: any) {
    return this.http.get(this.rootUrl + '/api/Marketing/GetProspectDetailForTheId/' + Pros_Id, this.httpOptions);
  }

  GetIssueForinternTheId(IS_Id: any) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueForinternTheId/' + IS_Id, this.httpOptions);
  }

  GetIssueForexternTheId(IS_Id: any) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueForexternTheId/' + IS_Id, this.httpOptions);
  }

  GetIssueViewForTheId(IS_Id: any) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueViewForTheId/' + IS_Id, this.httpOptions);
  }

  GetIssueResponse(IS_Ticket_No: any, IS_Id: any) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueResponse/' + IS_Ticket_No + "/" + IS_Id, this.httpOptions);
  }
  GetProspectResponse(Pros_Id: any) {
    return this.http.get(this.rootUrl + '/api/Marketing/GetProspectResponse/' + Pros_Id, this.httpOptions);
  }

  GetIssueinternResponse(IS_Ticket_No: any, IS_Id: any) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueinternResponse/' + IS_Ticket_No + "/" + IS_Id, this.httpOptions);
  }

  GetIssueexternResponse(IS_Ticket_No: any, IS_Id: any) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetIssueexternResponse/' + IS_Ticket_No + "/" + IS_Id, this.httpOptions);
  }

  GetAllStatus() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetAllStatus', this.httpOptions);
  }

  GetAllInternalStatus(Proj_ID) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetAllInternalStatus/' + Proj_ID, this.httpOptions);
  }

  GetexternStatus() {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetexternStatus', this.httpOptions);
  }
  GetAllUsers(IS_Id) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/GetAllUsers/' + IS_Id, this.httpOptions);
  }

  GetAllTeleUser() {
    return this.http.get(this.rootUrl + '/api/Marketing/GetAllTeleUser', this.httpOptions);
  }
  GetAllUserName(Pros_Id) {
    return this.http.get(this.rootUrl + '/api/Marketing/GetAllUserName/'+Pros_Id, this.httpOptions);
  }

  getClients(RoleId: any) {
    debugger
    return this.http.get(this.rootUrl + '/api/Users/GetClients/' + RoleId, this.httpOptions);
  }

  getOfficeForTheId(OfficeId: string) {
    return this.http.get(this.rootUrl + '/api/Offices/' + OfficeId, this.httpOptions);
  }
  GetNamesbyrole(roleId: string) {
    return this.http.get(this.rootUrl + '/api/Projects/' + roleId, this.httpOptions);
  }

  getAllClaims(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }

  GetAllRoleNames() {
    return this.http.get(this.rootUrl + '/api/Roles/GetAllOffices/', this.httpOptions);
  }

  getAllDistrictName() {
    debugger;
    return this.http.get(this.rootUrl + '/api/Users/GetAllDistrict', this.httpOptions);
  }

  getRolesforSelectedOffice() {
    return this.http.get(this.rootUrl + '/api/Roles/getRolesforSelectedOffice', this.httpOptions);
  }

  GetProjectsforRoles() {
    return this.http.get(this.rootUrl + '/api/Roles/getAllProjects', this.httpOptions);
  }


  GetAllOffices(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/GetAll/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }


  registerUser(register: Register) {
    return this.http.post(this.rootUrl + '/api/Account/Register', register, this.httpOptions);
  }

  registerCustomer(register: Register) {

    return this.http.post(this.rootUrl + '/api/CustomerAccount/Register', register, this.httpOptions);
  }

  createRole(user: User) {
    return this.http.post(this.rootUrl + '/api/Roles/Create', user, this.httpOptions);
  }

  createticket(projects: any) {

    return this.http.post(this.rootUrl + '/api/ProjectTicket/createticket', projects, this.httpOptions);
  }
  CreateProspect(prospect: any, Proj_ID) {

    return this.http.post(this.rootUrl + '/api/Marketing/createProspect/' + Proj_ID, prospect, this.httpOptions);
  }
  CreateProspectResponse(prosresp: any, Pros_Id,PR_Id) {

    return this.http.post(this.rootUrl + '/api/Marketing/CreateProspectResponse/' + Pros_Id+"/"+PR_Id, prosresp, this.httpOptions);
  }
  CreateProspectResponseNote(prosresp: any, Pros_Id,PR_Id) {

    return this.http.post(this.rootUrl + '/api/Marketing/CreateProspectResponseNote/' + Pros_Id+ "/"+PR_Id, prosresp, this.httpOptions);
  }
  createIssueResponse(issueres: any) {

    return this.http.post(this.rootUrl + '/api/ProjectTicket/createIssueResponse', issueres, this.httpOptions);
  }

  SaveDetails(IS_Status: any, IR_Note: any, IS_Id: any, userName) {

    return this.http.post(this.rootUrl + '/api/ProjectTicket/SaveDetails/' + IS_Status + "/" + IR_Note + "/" + IS_Id + "/" + userName, this.httpOptions);
  }

  updateViewStatus(IS_Id: any, userName) {
    return this.http.put(this.rootUrl + '/api/ProjectTicket/updateViewStatus/' + IS_Id + "/" + userName, this.httpOptions);
  }

  // SaveuserDetails(IR_Note: any, IS_Id: any, userName) {

  //   return this.http.post(this.rootUrl + '/api/ProjectTicket/SaveuserDetails/' + IR_Note + "/" + IS_Id + "/" + userName, this.httpOptions);
  // }

  SaveuserDetails(udm) {

    return this.http.post(this.rootUrl + '/api/ProjectTicket/SaveuserDetails',udm, this.httpOptions);
  }

  // CloseIssue(IS_Id: any, IS_Ticket_No: any, IR_Note: any, IS_DisplaytoCustomer, userName) {

  //   return this.http.post(this.rootUrl + '/api/ProjectTicket/CloseIssue/' + IS_Id + "/" + IS_Ticket_No + "/" + IR_Note + "/" + IS_DisplaytoCustomer + "/" + userName, this.httpOptions);
  // }

  CloseIssue(udm) {

    return this.http.post(this.rootUrl + '/api/ProjectTicket/CloseIssue' ,udm, this.httpOptions);
  }

  updateRole(user: User, roleId: string) {
    return this.http.put(this.rootUrl + '/api/Roles/Update/' + roleId, user, this.httpOptions);
  }

  searchRoles(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Roles/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }

  searchUsers(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Users/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }

  searchOffices(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/Offices/Search/' + searchCriteria + "/" + searchText + "/" + itemsPerPage + "/" + pageNo, this.httpOptions);
  }
  updateOffice(office: Office, OfficeId: string) {
    return this.http.put(this.rootUrl + '/api/Offices/Update/' + OfficeId, office, this.httpOptions);
  }

  saveClaims(claimsList, roleId) {
    return this.http.put(this.rootUrl + '/api/Claims/' + roleId, claimsList, this.httpOptions);
  }

  CreateOffice(office: Office) {
    return this.http.post(this.rootUrl + '/api/Offices/Create', office, this.httpOptions);
  }

  changePassword(userDetails: any) {
    return this.http.post(this.rootUrl + '/api/Account/ChangePassword', userDetails, this.httpOptions);
  }

  changePasswordForTheId(userDetails: any) {
    return this.http.put(this.rootUrl + '/api/Account/Update', userDetails, this.httpOptions);
  }

  deleteRole(id: string) {
    return this.http.put(this.rootUrl + '/api/Roles/Delete/' + id, this.httpOptions);
  }

  activateInactivateUser(id: string) {
    return this.http.put(this.rootUrl + '/api/Users/ActivateInactivate/' + id, null, this.httpOptions);
  }

  activateInactivateRoles(id: string) {
    return this.http.put(this.rootUrl + '/api/Roles/ActivateInactivate/' + id, null, this.httpOptions);
  }

  activateInactivateOffices(id: string) {
    return this.http.put(this.rootUrl + '/api/Offices/ActivateInactivate/' + id, null, this.httpOptions);
  }

  SearchTokens(searchCriteria: any, searchText: any) {
    return this.http.get(this.rootUrl + '/api/ProjectTicket/Search/' + searchCriteria + "/" + searchText+"/", this.httpOptions);
  }

  userAuthentication(user: Login) {
    var data = "username=" + user.UserName + "&password=" + user.Password + "&grant_type=password";
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' })
    }
    return this.http.post(this.rootUrl + '/token', data, httpOptions);
  }

  uploadImage(data) {
    return this.http.post(this.rootUrl + '/api/ProjectTicket/image', data);
  }

  //Reports Services
  getTodaysTickets(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/TodaysTicket', this.httpOptions);
  }

  getTodaysNewTickets(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/TodaysNewTicket', this.httpOptions);
  }

  getTodaysOpenTickets(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/TodaysOpenTicket', this.httpOptions);
  }

  getTodaysClosedTickets(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/TodaysClosedTicket', this.httpOptions);
  }

  todaysToBeResolvedTicket(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/TodaysToBeResolvedTicket', this.httpOptions);
  }

  newUnassignedTickets(FromDate:any,ToDate:any){
    return this.http.get(this.rootUrl + '/api/IssueTracker/NewUnassignedTickets/'+FromDate+'/'+ToDate , this.httpOptions);
  }

  totalOpenTickets(FromDate:any,ToDate:any){
    return this.http.get(this.rootUrl + '/api/IssueTracker/TotalOpenTickets/'+FromDate+'/'+ToDate, this.httpOptions);
  }

  totalClosedTickets(FromDate:any,ToDate:any){
    return this.http.get(this.rootUrl + '/api/IssueTracker/TotalClosedTickets/'+FromDate+'/'+ToDate, this.httpOptions);
  }

  ticketsToBeResolvedDatewise(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/TicketsToBeResolvedDatewise', this.httpOptions);
  }

  overdueReport(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/OverdueReport', this.httpOptions);
  }

  clientsAllTicketCount(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/ClientAllTicketsCount', this.httpOptions);
  }

  projectwiseClientsCount(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/ProjectwiseClientsCount', this.httpOptions);
  }

  clientsHighestTickets(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/ClientWithHighestTickets', this.httpOptions);
  }

  clientsLowestTickets(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/ClientWithLowestTickets', this.httpOptions);
  }

  clientsCountforProjects(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/ClientsCountforProjects', this.httpOptions);
  }

  priorityIssue(){
    return this.http.get(this.rootUrl + '/api/IssueTracker/PriorityIssue', this.httpOptions);
  }

  //varsha newly added

  getAllUserDesignations() {
    return this.http.get(this.rootUrl + '/api/InternalUserController/GetAllDesignations', this.httpOptions);
  }

  SaveInternalUserDetails(udm) {
    return this.http.post(this.rootUrl + '/api/InternalUserController/SaveInternalUserDetails',udm, this.httpOptions);
  }

  getAllInternalUsers(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.rootUrl + '/api/InternalUserController/GetAllInternalUsers/' + itemsPerPage + "/" + pageNo, this.httpOptions);
  }

  getInternalUser(id: string) {
    return this.http.get(this.rootUrl + '/api/InternalUserController/GetInternaluser/' + id, this.httpOptions);
  }

  updateInternalUser(internaluser:any,Tr_Id:any) {
    return this.http.put(this.rootUrl + '/api/InternalUserController/UpdateInternalUser/'+Tr_Id, internaluser, this.httpOptions);
}

  DeleteInternalUser(id: string,inActive:string) {
    debugger;
  return this.http.put(this.rootUrl + '/api/InternalUserController/DeleteInternalUser/' + id+ "/" + inActive, this.httpOptions);
}

SearchInternalUser(searchCriteria: any, searchText: any,itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/InternalUserController/SearchInternalUser/' + searchCriteria + "/" + searchText+"/" + itemsPerPage + "/" + pageNo, this.httpOptions);
}

GetAllCoordinators() {
  return this.http.get(this.rootUrl + '/api/ProjectTicket/GetAllCoordinators', this.httpOptions);
}

SaveProjectDetails(udm) {
  return this.http.post(this.rootUrl + '/api/ProjectTicket/SaveProjectDetails',udm, this.httpOptions);
}

getAllProjects(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/ProjectTicket/GetAllProjects/' + itemsPerPage + "/" + pageNo, this.httpOptions);
}

getProject(id: string) {
  return this.http.get(this.rootUrl + '/api/ProjectTicket/GetProjectDetailsById/' + id, this.httpOptions);
}


updateprojectdetails(project:any,Tr_Pro_Id:any) {
  return this.http.put(this.rootUrl + '/api/ProjectTicket/UpdateProject/'+Tr_Pro_Id, project, this.httpOptions);
}

DeleteProject(id: string) {
  debugger;
return this.http.put(this.rootUrl + '/api/ProjectTicket/DeleteProject/' + id, this.httpOptions);
}

//clients
getAllDistricts() {
  return this.http.get(this.rootUrl + '/api/ClientController/GetAllDistricts', this.httpOptions);
} 

getAllTaluks(districtId:any) {
  return this.http.get(this.rootUrl + '/api/ClientController/GetAllTaluks/' + districtId, this.httpOptions);
} 

SaveClientDetails(udm) {
  return this.http.post(this.rootUrl + '/api/ClientController/SaveClientDetails',udm, this.httpOptions);
}

getAllClients(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/ClientController/GetAllClients/' + itemsPerPage + "/" + pageNo, this.httpOptions);
}

getClientDetailsById(id: string) {
  return this.http.get(this.rootUrl + '/api/ClientController/GetClientDetailsById/' + id, this.httpOptions);
}

updateclientdetails(client:any,C_Id:any) {
  return this.http.put(this.rootUrl + '/api/ClientController/UpdateClient/'+C_Id, client, this.httpOptions);
}

DeleteClient(id: string) {
  debugger;
return this.http.put(this.rootUrl + '/api/ClientController/DeleteClient/' + id, this.httpOptions);
}

getAllProjectsForDropdown() {
  return this.http.get(this.rootUrl + '/api/ClientController/GetAllProjects', this.httpOptions);
} 

SearchProject(searchCriteria: any, searchText: any,itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/ProjectTicket/SearchProject/' + searchCriteria + "/" + searchText+"/" + itemsPerPage + "/" + pageNo, this.httpOptions);
}

SearchClient(searchCriteria: any, searchText: any,itemsPerPage: number, pageNo: number) {
  return this.http.get(this.rootUrl + '/api/ClientController/SearchClient/' + searchCriteria + "/" + searchText+"/" + itemsPerPage + "/" + pageNo, this.httpOptions);
}

//EmployeewiseClosedReport

employeewiseClosedTicketsReport(FromDate:any,ToDate:any,InternaluserId:any){
  return this.http.get(this.rootUrl + '/api/IssueTracker/EmployeewiseClosedTicketsReport/'+FromDate+'/'+ToDate+ "/" + InternaluserId, this.httpOptions);
}

employeewisePendingTicketsReport(FromDate:any,ToDate:any,InternaluserId:any){
  return this.http.get(this.rootUrl + '/api/IssueTracker/EmployeewisePendingTicketsReport/'+FromDate+'/'+ToDate+ "/" + InternaluserId, this.httpOptions);
}

getInternalUsersForDropdown() {
  return this.http.get(this.rootUrl + '/api/IssueTracker/GetAllInternalUsers/', this.httpOptions);
}

overallreport(FromDate:any,ToDate:any){
  debugger;
  return this.http.get(this.rootUrl + '/api/IssueTracker/overallreport/'+FromDate+'/'+ToDate, this.httpOptions);
}

}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts